import {
  TAGS_ALL,
  TAGS_ALL_SUCCESS,
  TAGS_CREATE,
  TAGS_CREATE_SUCCESS,
  TAGS_DELETE,
  TAGS_DELETE_SUCCESS,
  TAGS_GET,
  TAGS_GET_SUCCESS,
  TAGS_UPDATE,
  TAGS_UPDATE_SUCCESS,
} from '../constants/Tags';

const initialState = {
  tag: {
    id: null,
    name: '',
    color: '',
  },
  tags: null,
  loading: false,
};

const tags = (state = initialState, action) => {
  switch (action.type) {
    case TAGS_ALL:
      return {
        ...state,
        loading: true,
      };
    case TAGS_ALL_SUCCESS:
      return {
        ...state,
        tags: action.tags,
        loading: false,
      };
    case TAGS_GET:
      return {
        ...state,
        loading: true,
      };
    case TAGS_GET_SUCCESS:
      return {
        ...state,
        tag: action.tag,
        loading: false,
      };
    case TAGS_CREATE:
      return {
        ...state,
        loading: true,
      };
    case TAGS_CREATE_SUCCESS:
      return {
        ...state,
        tags: [...state.tags, action.tag],
        loading: false,
      };
    case TAGS_UPDATE:
      return {
        ...state,
        loading: true,
      };
    case TAGS_UPDATE_SUCCESS:
      return {
        ...state,
        tag: action.tag,
        tags: state.tags.map((t) => {
          if (action.tag.id === t.id) {
            return action.tag;
          }
          return t;
        }),
        loading: false,
      };
    case TAGS_DELETE:
      return {
        ...state,
        loading: true,
      };
    case TAGS_DELETE_SUCCESS:
      return {
        ...state,
        tags: state.tags ? state.tags.filter((t) => t.id !== action.tagId) : [],
        loading: false,
      };
    default:
      return state;
  }
};

export default tags;
